module.exports = __webpack_public_path__ + "img/hr-H-T-123456-unload-standup-top.00a23999.png";